import { Drawer } from '@abyss/web/ui/Drawer';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';
import { Text } from '@abyss/web/ui/Text';
import { useState } from 'react';

import { InfoStyledDrawer } from './SmartChoice.styled';

export const InfoDrawerOrPopover = ({ mobileScreen, title, content }) => {
  const [openDrawerOrPopover, setOpenDrawerOrPopover] = useState(false);
  const handleClose = () => setOpenDrawerOrPopover(false);
  const handleOpen = () => setOpenDrawerOrPopover(true);
  if (mobileScreen) {
    return (
      <>
        <span
          onClick={handleOpen}
          style={{ cursor: 'pointer', display: 'inline-flex' }}
        >
          <IconSymbol
            color={'#196ECF'}
            icon="info"
            size={16.67}
            variant="outlined"
          />
        </span>
        <InfoStyledDrawer
          css={{
            '.abyss-modal-content-container': {
              '@screen < $sm': {
                height: 'auto !important',
                maxHeight: '70vh',
                overflowY: 'auto',
              },
            },
          }}
          isOpen={openDrawerOrPopover}
          onClose={handleClose}
          position={'bottom'}
          size={'sm'}
          title={
            <Text
              color="$primary"
              css={{
                fontSize: '24px !important',
                fontWeight: 700,
                paddingTop: '0px',
              }}
              data-testid="smart-choice-preferences-heading"
            >
              {title}
            </Text>
          }
        >
          <Drawer.Section>{content}</Drawer.Section>
        </InfoStyledDrawer>
      </>
    );
  }
  return (
    <Popover
      content={content}
      onOpenChange={setOpenDrawerOrPopover}
      open={openDrawerOrPopover}
      position={'right'}
      title={title}
    >
      <span
        onClick={handleOpen}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
      >
        <IconSymbol
          color={'#196ECF'}
          icon="info"
          size={16.67}
          variant="outlined"
        />
      </span>
    </Popover>
  );
};
